import './Navbar.css'
import { useState } from 'react';
import { useNavigate } from "react-router-dom";
import cowonderMiniLogo from '@/assets/cowonderminilogo.png';
import { isAuthenticated } from '@/utils/auth/isAuthenticated';

// TODO: Make 2 files instead of a fully chimera
function Navbar({ scrollToSection }: { scrollToSection: (_id: string) => void }) {
  const navigate = useNavigate();
  const [showing, setShowing] = useState(true);
  const stored = localStorage.getItem("harenaCowonder") || localStorage.getItem("harenaCowonderAuth");
  const logged = stored ? isAuthenticated(stored) : false;
  const notShowingNavBar = () => {
    if (window.scrollY ==0 || window.scrollY <= 680) setShowing(true);
    else setShowing(false);
  };
  window.addEventListener('scroll', notShowingNavBar);
  const [isOpen, setIsOpen] = useState(true);
  const toggleMenu = () => setIsOpen((open) => !open);
  const handleClose = () => setIsOpen((open) => !open);

  return (
    <>

    <nav className={!showing ? 'navbar bg-[--primary-color-hover]' : 'navbar bg-none' } style={{zIndex:10000}}>
      <div className="text-white flex items-center justify-center py-6 w-full">
        {/* DESKTOP */}
        <div className="flex items-center">
          <button onClick={() => scrollToSection("home")} className="mr-6 hidden lg:block">
            <img src={cowonderMiniLogo} alt="Logo Cowonder" className="w-[40px] h-auto sm:w-[30px] hover:opacity-80 transition-opacity" />
          </button>

          <button className="nav-button" onClick={() => scrollToSection("home")}>Início</button>
          <button className="nav-button" onClick={() => scrollToSection("servicos")}>Serviços</button>
          <button className="nav-button" onClick={() => scrollToSection("pricing")}>Preços</button>
          <button className="nav-button" onClick={() => scrollToSection("contact")}>Contato</button>
        </div>

        {/* ENTRAR - WEB */}
        <div className="flex items-center">
          <button
            className="nav-button nav-button-highlight"
            onClick={(e) => {
              e.preventDefault();
              navigate(logged ? "/dashboard" : "/login");
            }}
          >
            {logged ? "Dashboard" : "Entrar"}
          </button>
        </div>

        {/* MOBILE */}
        <div className="flex flex-col items-center w-full lg:hidden">
          <button className="dropbtn flex self-start px-4" onClick={toggleMenu}>
            <img src={cowonderMiniLogo} alt="Logo Cowonder" className="w-[40px] h-auto sm:w-[30px] hover:opacity-80 transition-opacity" />
          </button>

          <ul className={`flex flex-col justify-around h-[10%] w-full mt-5 ${showing ? 'bg-[--primary-color-hover]' : 'bg-none'}`}>
            <li className={`menu-button ${isOpen ? 'closed' : 'open'}`} onClick={() => scrollToSection("home")}>Início</li>
            <li className={`menu-button ${isOpen ? 'closed' : 'open'}`} onClick={() => scrollToSection("servicos")}>Serviços</li>
            <li className={`menu-button ${isOpen ? 'closed' : 'open'}`} onClick={() => scrollToSection("pricing")}>Preços</li>
            <li className={`menu-button ${isOpen ? 'closed' : 'open'}`} onClick={() => scrollToSection("contact")}>Contato</li>
            <li
              className={`menu-button ${isOpen ? 'closed' : 'open'}`}
              onClick={(e) => {
                e.preventDefault();
                navigate(logged ? "/dashboard" : "/login");
                handleClose();
              }}
            >
              {logged ? "Dashboard" : "Entrar"}
            </li>
          </ul>
        </div>
      </div>
    </nav>

    </>
  );
}

export default Navbar;
